import { classNames } from "../../style/common"
import { Button } from "./Button/Button"

export type ToggleButtonProps = {
    value: boolean,
    update: (values: boolean) => void,
    text: {
        on: string,
        off: string
    },
    classNames?: {
        button?: string
    }
}

export function ToggleButton(props: ToggleButtonProps) {
    return (
        <Button
            className={classNames("flex items-center justify-center", props.classNames?.button)}
            color={props.value ? "emphasis" : "component"}
            onClick={() => props.update(!props.value)}
        >
            <span>{props.value ? props.text.on : props.text.off }</span>
        </Button>
    )
}